
  document.getElementById('call-us-button').textContent = "Call (480) 229-3400";
  var stickyBar = document.getElementById('custom-sticky-bar');
  var hasScrolled = false;
  var delay = 2000; 

  window.addEventListener('scroll', function() {
    var scrollPosition = window.scrollY;

    if (scrollPosition > 100 && !hasScrolled) {
      setTimeout(function() {
        stickyBar.style.top = '20px'; 
      }, delay); 
      hasScrolled = true; 
    } else if (scrollPosition <= 100) {
      stickyBar.style.top = '-100px'; 
      hasScrolled = false; 
    }
  });

  document.getElementById('call-us-button').addEventListener('click', function() {
    window.location.href = 'tel:{{ settings.sticky_bar_phone_number }}'; 
  });

  var hamburgerMenu = document.getElementById('hamburger-menu'); 
  if (hamburgerMenu) {
    hamburgerMenu.addEventListener('click', function() {
      stickyBar.style.top = '20px';
    });
  }

  var closeButton = document.getElementById('sticky-bar-close');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      stickyBar.style.top = '-100px'; 
    });
  }


// tabbing section js
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const contentId = this.dataset.contentId;
      const content = document.getElementById(contentId);

      tabContents.forEach(function(c) {
        c.classList.remove('active');
      });

      tabs.forEach(function(t) {
        t.classList.remove('active');
      });

      this.classList.add('active');
      if(content) content.classList.add('active');
    });
  });


